var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 39.004,
    height: 39.003,
    viewBox: "0 0 39.004 39.003",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 1.003px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke: #575756;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke-miterlimit: 10;\n        stroke-width: 2.4px;\n      }\n\n      .cls-3 {\n        filter: url(#Trazado_686);\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Trazado_686",
    x: 0,
    y: 0,
    width: 39.004,
    height: 39.003,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.239
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bot\\xF3n_nuevo",
    "data-name": "bot\\xF3n nuevo",
    transform: "translate(3.502 1.501)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3",
    transform: "matrix(1, 0, 0, 1, -3.5, -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_686-2",
    "data-name": "Trazado 686",
    className: "cls-1",
    d: "M16,0A16,16,0,1,1,0,16,16,16,0,0,1,16,0Z",
    transform: "translate(3.5 1.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20",
    transform: "translate(9.685 9.685)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_1",
    "data-name": "L\\xEDnea 1",
    className: "cls-2",
    y2: 12.63,
    transform: "translate(6.315)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_2",
    "data-name": "L\\xEDnea 2",
    className: "cls-2",
    x2: 12.63,
    transform: "translate(0 6.315)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewButton);
export default __webpack_public_path__ + "static/media/newButton.4b7816c8c6290036e237613bdbd471cc.svg";
export { ForwardRef as ReactComponent };